export class Pac_ComQuestionValue {
    PC_ComQuestionValueID?: number;
    ComQuestionID?: number;
    ComAnswerValue?: string;
    isActive?: number;    
}
export class Pac_DelayReasons {
    DelayReason_ID?: number;
    DelayReasonText?: string;
    Activeflag?: boolean;    
}

export class Pac {
    PACQuestionID?: number;
    PACID?: number;
    QuestionText?: string;  
    isActive?: number;
    AnswerValue:string;
    PC_QuestionValueID?:number;
    ResponseTypeID?:number;
}

export class CHECKLIST_Model {
    SortOrder?: number;
    EquipmentID?: number;
    QuestionID?: number;   
    QuestionText?: string; 
    Name?: string; 
    Symbol?: string; 
    DataType?: string;  
    AcceptableRange?: string; 
    MonitorLocation?: string; 
    Formula?: string; 
    ResponseText?: string; 
    RowNum:number;
}


export class facilityEquipment {
    facilityName?: string;
    MachineNickName?: string;
    facilityMasterid?: number;  
    regionMasterId?: number;
    regionName?:string;
    divisionMasterId?:number;
    divisionName?:string;
    facilityNumber?:number;
    EquipmentID?:number;
    locationtypeid?:number;
    locationName?:string;
    ModelID?:number;
    EquipmentSerialNumber?:string;
    clockhours?:string;
    equipmentDescription?:string;
    DateOfOriginalInstall?:string;
    DateOfLastRepair?:string;
    DateModified?:string;
    DateWarrantyExpires?:string;
    DateOfLastPM?:string;
    modifiedby?:number;
    equipmentModalityId?:number;
    isCustomScheduleActiveFlag?:number;
    status?:string;
    ModelDescription?:string;
    modelNumber?:string;
    EquipmentTypeID?:number;
    EquipmentSubTypeID?:number;
    ManufacturerID?:number;
    IsNickNameEnabled?:boolean;
    ManufacturerName?:string;
    EquipmentTypeDescription?:string;
    EquipmentSubTypeDescription?:string;
    equipmentstatusid?:string;
    fullname?:string;
    modalityDescription?:string;
    equipmentConditionId?:string;
    equipmentCondition?:string;
    equipmentOriginId?:number;
    equipmentOrigin?:string;
    MPI?:string;
    PACList?:string;
    IsIpAddressEnabled?:boolean;
    MachineIPAddress?:string;
    facility:string;
}







